import InviteList from "@/components/InvitationDialogStacks/InviteList";
import { useCurrentUser } from "@/queries/users";
import { useWorkspaceInvites } from "@/queries/workspace-invites";

const InvitationDialogStacks = () => {
  const user = useCurrentUser();
  const currentUserInvites = useWorkspaceInvites({
    invitee_email: user.data?.email,
  });
  const invites = currentUserInvites.data?.items || [];

  if (
    user.isLoading ||
    (!currentUserInvites.isFetching && invites.length === 0)
  )
    return null;

  return <InviteList invites={invites} />;
};

export default InvitationDialogStacks;
